{
  "requests.title": "الطلبات",
  "requests.subtitle": "كل ما ينتظر قرارك: الحضور والإجازات والساعات الإضافية ومطالبات المصروفات والخطابات.",
  "requests.tabs.label": "أقسام الطلبات",
  "requests.tabs.inbox": "بانتظارك",
  "requests.tabs.delegations": "أثناء غيابي",
  "requests.nav.waiting": "{count, plural, one {طلب واحد بانتظارك} two {طلبان بانتظارك} few {# طلبات بانتظارك} many {# طلبًا بانتظارك} other {# طلب بانتظارك}}",

  "requests.group.attendance_request": "طلبات الحضور",
  "requests.group.leave_request": "الإجازات",
  "requests.group.overtime": "الساعات الإضافية",
  "requests.group.expense_claim": "مطالبات المصروفات",
  "requests.group.letter_request": "خطابات الموارد البشرية",
  "requests.subject.overtime": "ساعات إضافية",
  "requests.subject.expense_claim": "مطالبة مصروفات",
  "requests.overtime.workday": "يوم عمل",
  "requests.overtime.rest_day": "يوم راحة",
  "requests.overtime.holiday": "عطلة رسمية",
  "requests.facts.range": "{start} – {end}",

  "requests.inbox.asked": "قُدِّم {when}",
  "requests.balance.after": "يتبقى له {days} من {type} بعد هذا الطلب",
  "requests.balance.short": "الطلب أكبر من رصيده: ناقص {days} من {type}",
  "requests.inbox.approve": "موافقة",
  "requests.inbox.reject": "رفض",
  "requests.inbox.approveOne": "موافقة على {label} من {name}",
  "requests.inbox.rejectOne": "رفض {label} من {name}",
  "requests.inbox.selectOne": "تحديد {label} من {name}",
  "requests.inbox.selectAll": "تحديد الكل",
  "requests.inbox.selected": "{count, plural, one {طلب واحد محدد} two {طلبان محددان} few {# طلبات محددة} many {# طلبًا محددًا} other {# طلب محدد}}",
  "requests.inbox.approveSelected": "موافقة على {count, plural, =0 {المحدد} one {طلب واحد} two {طلبين} few {# طلبات} many {# طلبًا} other {# طلب}}",
  "requests.inbox.approved": "تمت الموافقة على طلب {name}.",
  "requests.inbox.rejected": "تم رفض طلب {name}.",
  "requests.inbox.bulkApproved": "{count, plural, one {تمت الموافقة على طلب واحد.} two {تمت الموافقة على طلبين.} few {تمت الموافقة على # طلبات.} many {تمت الموافقة على # طلبًا.} other {تمت الموافقة على # طلب.}}",
  "requests.inbox.bulkPartial": "{count, plural, one {تمت الموافقة على طلب واحد} two {تمت الموافقة على طلبين} few {تمت الموافقة على # طلبات} many {تمت الموافقة على # طلبًا} other {تمت الموافقة على # طلب}}، وتعذّر {total}. بقيت محددة لتراجعها مرة أخرى.",
  "requests.inbox.loadError": "تعذّر تحميل طلباتك.",
  "requests.inbox.empty.title": "لا شيء بانتظارك",
  "requests.inbox.empty.body": "تظهر هنا طلبات فريقك الجديدة، والطلبات التي تصل إلى الموارد البشرية.",

  "requests.bulk.title": "الموافقة على {count, plural, one {طلب واحد} two {طلبين} few {# طلبات} many {# طلبًا} other {# طلب}}؟",
  "requests.bulk.body": "ينتقل كل طلب إلى خطوته التالية، أو تتم الموافقة عليه إن كانت خطوتك الأخيرة. ويُبلَّغ أصحابها فورًا.",
  "requests.reject.title": "رفض طلب {name}؟",
  "requests.reject.body": "اذكر السبب ليتمكن من التقديم مرة أخرى بما ينقص.",
  "requests.reject.comment": "التعليق",
  "requests.reject.confirm": "رفض الطلب",

  "requests.timeline.label": "خطوات الموافقة",
  "requests.timeline.show": "خطوات الموافقة",
  "requests.timeline.asked": "قُدِّم الطلب",
  "requests.timeline.role.manager": "المدير",
  "requests.timeline.role.hr": "الموارد البشرية",
  "requests.timeline.manager": "مديره المباشر",
  "requests.timeline.hrTeam": "فريق الموارد البشرية",
  "requests.timeline.state.waiting": "التالي",
  "requests.timeline.state.current": "قيد القرار الآن",
  "requests.timeline.state.approved": "وافق",
  "requests.timeline.state.rejected": "رفض",
  "requests.timeline.state.skipped": "تم تخطيه",

  "requests.delegations.intro": "أثناء غيابك، يقرر زميل تثق به في طلبات فريقك بدلًا منك. خطوات الموارد البشرية لا تُفوَّض.",
  "requests.delegations.add": "تفويض",
  "requests.delegations.addTitle": "تفويض موافقاتك",
  "requests.delegations.addBody": "يقرر في خطوة المدير لطلبات فريقك بين هذين التاريخين.",
  "requests.delegations.person": "من يقرر بدلًا منك",
  "requests.delegations.pick": "اختر زميلًا",
  "requests.delegations.search": "ابحث عن شخص",
  "requests.delegations.noPeople": "لا يوجد تطابق.",
  "requests.delegations.from": "من",
  "requests.delegations.to": "حتى",
  "requests.delegations.save": "تفويض",
  "requests.delegations.added": "تم تفويض الموافقات.",
  "requests.delegations.incomplete": "اختر زميلًا والتاريخين.",
  "requests.delegations.endBeforeStart": "يجب ألا يسبق آخر يوم أول يوم.",
  "requests.delegations.active": "سارٍ الآن",
  "requests.delegations.remove": "إيقاف التفويض إلى {name}",
  "requests.delegations.removeTitle": "إيقاف التفويض إلى {name}؟",
  "requests.delegations.removeBody": "تعود إليك طلبات فريقك من الآن.",
  "requests.delegations.removeConfirm": "إيقاف التفويض",
  "requests.delegations.removed": "تم إيقاف التفويض.",
  "requests.delegations.loadError": "تعذّر تحميل التفويضات.",
  "requests.delegations.empty.title": "لا توجد تفويضات",
  "requests.delegations.empty.body": "مسافر أو في إجازة؟ اترك لزميل القرار في طلبات فريقك خلالها.",

  "requests.errors.gone": "هذا الطلب لم يعد موجودًا.",
  "requests.errors.closed": "تم البت في هذا الطلب أو سحبه بالفعل.",
  "requests.errors.notYours": "لم يعد القرار في هذه الخطوة لك.",
  "requests.errors.delegation": "اختر زميلًا نشطًا غيرك، وتاريخين مرتبين.",
  "requests.errors.balance": "رصيد الإجازات لا يكفي للموافقة على هذا الطلب.",

  "requests.notify.subject.attendance_request": "طلب حضور",
  "requests.notify.subject.leave_request": "طلب إجازة",
  "requests.notify.subject.overtime": "طلب ساعات إضافية",
  "requests.notify.subject.expense_claim": "مطالبة مصروفات",
  "requests.notify.subject.letter_request": "طلب خطاب",
  "requests.notify.yours.attendance_request": "طلب الحضور الخاص بك",
  "requests.notify.yours.leave_request": "طلب الإجازة الخاص بك",
  "requests.notify.yours.overtime": "طلب الساعات الإضافية الخاص بك",
  "requests.notify.yours.expense_claim": "مطالبة المصروفات الخاصة بك",
  "requests.notify.yours.letter_request": "طلب الخطاب الخاص بك",
  "requests.notify.pending": "{target} من {actor} بانتظار قرارك",
  "requests.notify.decided": "{status, select, approved {تمت الموافقة على {target}} rejected {تم رفض {target}} other {تم البت في {target}}}",
  "requests.notify.alert.contract_ending": "ينتهي عقد {name} {days, plural, =0 {اليوم} one {خلال يوم واحد} two {خلال يومين} few {خلال # أيام} many {خلال # يومًا} other {خلال # يوم}} ({date})",
  "requests.notify.alert.probation_ending": "تنتهي فترة اختبار {name} {days, plural, =0 {اليوم} one {خلال يوم واحد} two {خلال يومين} few {خلال # أيام} many {خلال # يومًا} other {خلال # يوم}} ({date})",
  "requests.notify.alert.document_expiring": "ينتهي مستند {target} الخاص بـ{name} {days, plural, =0 {اليوم} one {خلال يوم واحد} two {خلال يومين} few {خلال # أيام} many {خلال # يومًا} other {خلال # يوم}} ({date})",
  "requests.notify.alert.certification_expiring": "تنتهي شهادة {target} الخاصة بـ{name} {days, plural, =0 {اليوم} one {خلال يوم واحد} two {خلال يومين} few {خلال # أيام} many {خلال # يومًا} other {خلال # يوم}} ({date})",
  "requests.notify.alert.asset_not_returned": "غادر {name} منذ {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}} وما زال معه {target}",
  "requests.notify.alert.break_overrun": "{name} تجاوز وقت الاستراحة المسموح بـ{minutes, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} يوم {date}",
  "requests.notify.reviewRequested": "طُلب منك كتابة تقييمات دورة {target} قبل {date}",
  "requests.notify.reviewReminder": "تذكير: تقييمات دورة {target} مستحقة {date}",
  "requests.notify.reviewPublished": "نتيجة تقييمك في دورة {target} جاهزة",
  "requests.notify.feedback.praise": "أرسل لك {actor} إشادة",
  "requests.notify.feedback.private": "أرسل لك {actor} ملاحظة",
  "requests.notify.feedback.requested": "أرسل لك {actor} الرأي الذي طلبته",
  "requests.notify.feedbackRequested": "يطلب منك {actor} رأيك في {target}",
  "requests.notify.feedbackRequestedBy": "يطلب منك {actor} رأيك في {target} قبل {date}",
  "requests.notify.applicationReceived": "{name} تقدّم لوظيفة {target}",
  "requests.notify.interviewScheduled": "أنت في لجنة مقابلة {name} ({target}) يوم {date}",
  "requests.notify.offerAccepted": "{name} قبل عرض وظيفة {target}",
  "requests.notify.offerDeclined": "{name} اعتذر عن عرض وظيفة {target}",
  "requests.routes.title": "مين يوافق على إيه",
  "requests.routes.description": "كل نوع طلب بيروح للناس دي بالترتيب. النوع اللي سايبه على إعداد مجموعته بيمشي زيها. الطلبات المفتوحة بتفضل على خطواتها.",
  "requests.routes.readOnly": "كل نوع طلب بيروح للناس دي بالترتيب. مديرين الموارد البشرية بس يقدروا يغيّروا ده.",
  "requests.routes.managerOnlyHint": "«المدير بس» بيروح للموارد البشرية لو الشخص مالوش مدير.",
  "requests.routes.caption": "مسارات الموافقة",
  "requests.routes.columns.request": "الطلب",
  "requests.routes.columns.steps": "يوافق عليه",
  "requests.routes.steps.manager_then_hr": "المدير، وبعده الموارد البشرية",
  "requests.routes.steps.hr_only": "الموارد البشرية بس",
  "requests.routes.steps.manager_only": "المدير بس",
  "requests.routes.inherit": "زي المجموعة",
  "requests.routes.selectLabel": "مين يوافق على {label}",
  "requests.routes.saved": "اتحفظ مين يوافق على {label}.",
  "requests.routes.loadError": "تعذّر تحميل مسارات الموافقة."
}
